const Enums = Object.freeze({
  endpoints: {
    auth: {
      LOGIN: "/auth/login",
      SIGNUP: "/auth/signup",
      LOGOUT: "/auth/logout",
      REFRESH: "/auth/refresh",
      ME: "/auth/me",
      ACTIVATE: "/auth/activate/[token]",
      FORGOT_PASSWORD: "/auth/forgot-password",
      RESET_PASSWORD: "/auth/reset-password/[token]",
      CHANGE_PASSWORD: "/auth/change-password",
    },
    store: {
      ALL: "/store/all",
      AGGR: "/store/aggregate",
      WOO: "/store/woo",
      DETAIL: "/store/[id]",
      WOO_AUTH: "/store/woo/auth",
      SEARCH: "/store/search",
    },
    orders: {
      ALL: "/orders",
      DETAIL: "/orders/[id]",
      DELETE_ONE: "/orders/[id]",
    },
    stats: {
      STORES: "/stats/stores",
      STORES_ORDER_COUNT: "/stats/storesByOrderCount",
      ORDER_COUNT_BY_DAY: "/stats/ordersReport",
      DASHBOARD: "/stats/dashboard",
    },
    tiktok: {
      AUTH_TOKEN: "/tiktok/auth/token/[id]",
      CREATE_LABLE: "/tiktok/fulfillment",
      CREATE_FLASH_SALE: "/tiktok/promotion/createFlashDeal",
    },
    google: {
      oauth2: "/google/oauth2",
      oauth2Callback: "/google/oauth2/callback",
      oauth2Refresh: "/google/oauth2/refresh",
      oauth2Disconnect: "/google/oauth2/disconnect",
    },
    options: {
      SAVE: "/options",
      LIST: "/options",
      DELETE: "/options/[id]",
    },
    media: {
      IMG: "/media/image",
    },
    paypal: {
      ACCOUNT: "/gateway/paypal/account",
      ACCOUNT_PR: "/gateway/paypal/account/[id]",
      ACCOUNT_TEST: "/gateway/paypal/account/[id]/test",
      EXPORT_PAYMENTS_INIT: "/gateway/paypal/tools/export-payments/init",
      EXPORT_PAYMENTS_CHUNK: "/gateway/paypal/tools/export-payments/chunk",
      EXPORT_DISPUTES_INIT: "/gateway/paypal/tools/export-disputes/init",
      EXPORT_DISPUTES_CHUNK: "/gateway/paypal/tools/export-disputes/chunk",
      EXPORT_REFUNDS_INIT: "/gateway/paypal/tools/export-refunds/init",
      EXPORT_REFUNDS_CHUNK: "/gateway/paypal/tools/export-refunds/chunk",
      EXPORT_TRACKING_INIT: "/gateway/paypal/tools/export-tracking/init",
      EXPORT_TRACKING_CHUNK: "/gateway/paypal/tools/export-tracking/chunk",
      EXPORT_TRACKING_AUTO_INIT: "/gateway/paypal/tools/export-tracking/auto-init",
      ADD_TRACKING_INIT: "/gateway/paypal/tools/add-tracking/init",
      ADD_TRACKING_CHUNK: "/gateway/paypal/tools/add-tracking/chunk",
      ADD_TRACKING_AUTO_INIT: "/gateway/paypal/tools/add-tracking/auto-init",
      // Dispute management — sync + actions are keyed by disputeId server-side.
      DISPUTES_SYNC: "/gateway/paypal/disputes/sync",
      DISPUTES_SYNC_INIT: "/gateway/paypal/disputes/sync/init",
      DISPUTES_SYNC_CHUNK: "/gateway/paypal/disputes/sync/chunk",
      DISPUTES_EXPORT_SHEET_INIT: "/gateway/paypal/disputes/export-sheet/init",
      DISPUTES_EXPORT_SHEET_CHUNK: "/gateway/paypal/disputes/export-sheet/chunk",
      DISPUTES_LIST: "/gateway/paypal/disputes",
      DISPUTES_DELETE: "/gateway/paypal/disputes",
      DISPUTES_STATS: "/gateway/paypal/disputes/stats",
      DISPUTES_DETAIL: "/gateway/paypal/disputes/[id]",
      DISPUTES_REFRESH: "/gateway/paypal/disputes/[id]/refresh",
      DISPUTES_ACCEPT_CLAIM: "/gateway/paypal/disputes/[id]/accept-claim",
      DISPUTES_OFFER: "/gateway/paypal/disputes/[id]/offer",
      DISPUTES_SEND_MESSAGE: "/gateway/paypal/disputes/[id]/send-message",
      DISPUTES_ESCALATE: "/gateway/paypal/disputes/[id]/escalate",
      DISPUTES_ACKNOWLEDGE_RETURN: "/gateway/paypal/disputes/[id]/acknowledge-return-item",
      DISPUTES_PROVIDE_EVIDENCE: "/gateway/paypal/disputes/[id]/provide-evidence",
      DISPUTES_TRANSLATE: "/gateway/paypal/disputes/[id]/translate",
      // Background jobs (Bull / Redis on the server).
      JOBS_CREATE: "/gateway/paypal/jobs",
      JOBS_LIST: "/gateway/paypal/jobs",
      JOBS_ACTIVE: "/gateway/paypal/jobs/active",
      JOBS_DETAIL: "/gateway/paypal/jobs/[id]",
      JOBS_CANCEL: "/gateway/paypal/jobs/[id]/cancel",
      JOBS_DELETE: "/gateway/paypal/jobs/[id]",
      JOBS_CLEAR_FINISHED: "/gateway/paypal/jobs/finished",
    },
    woo: {
      // List user's connected WooCommerce stores (id, name, domain, connected).
      STORES: "/gateway/woo/stores",
      // Bulk-delete orders for re-sync from scratch.
      ORDERS_DELETE_ALL: "/gateway/woo/orders/delete-all",
      // Background jobs (Bull / Redis on the server).
      JOBS_CREATE: "/gateway/woo/jobs",
      JOBS_LIST: "/gateway/woo/jobs",
      JOBS_ACTIVE: "/gateway/woo/jobs/active",
      JOBS_DETAIL: "/gateway/woo/jobs/[id]",
      JOBS_CANCEL: "/gateway/woo/jobs/[id]/cancel",
      JOBS_DELETE: "/gateway/woo/jobs/[id]",
      JOBS_CLEAR_FINISHED: "/gateway/woo/jobs/finished",
    },
    workspace: {
      ALL: "/workspace",
      DETAIL: "/workspace/[id]",
      MEMBER: "/workspace/member",
    },
    ext: {
      API_TOKEN: "/integration/token",
    },
    apiKeys: {
      LIST: "/api-keys",
      CREATE: "/api-keys",
      REVOKE: "/api-keys/[id]/revoke",
      DELETE: "/api-keys/[id]",
    },
    mailtemplate: {
      ALL: "/mailtemplate",
    },
    supplierStock: {
      SUPPLIERS: "/supplier-stock/suppliers",
      PRODUCTS: "/supplier-stock/products",
      SHEET_NAMES: "/supplier-stock/sheets/names",
      SHEET_EXPORT_STOCK: "/supplier-stock/sheets/export-stock",
      SHEET_SYNC_STOCK: "/supplier-stock/sheets/sync-stock",
    },
    toolSupport: {
      SHEET_DATA: "/tool-support/sheets/data",
      VALIDATE_INIT: "/tool-support/fulfillment/validate-address/init",
      VALIDATE_BATCH: "/tool-support/fulfillment/validate-address/batch",
      VALIDATE_WRITE: "/tool-support/fulfillment/validate-address/write",
      EXPORT_ORDERS: "/tool-support/orders/export",
      EXPORT_ORDERS_PAGE: "/tool-support/orders/export-page",
    },
  },
  Regex: {
    NAME: /^[a-zA-Z][a-zA-Z0-9 ]{2,23}$/,
    EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    PASS: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{6,24}$/,
  },
});

export default Enums;
